if (!customElements.get('nav-redesign')) {
  customElements.define('nav-redesign', class NavRedesign extends HTMLElement {
    connectedCallback() {
      this.triggers = [...this.querySelectorAll('[data-nav-redesign-trigger]')];
      this.closeTimer = null;
      this.hoverOpenedTrigger = null;

      this.triggers.forEach((trigger) => {
        const item = trigger.closest('.nav-redesign__item');
        trigger.addEventListener('click', () => {
          const wasJustOpenedByHover = this.hoverOpenedTrigger === trigger
            && trigger.getAttribute('aria-expanded') === 'true';

          this.hoverOpenedTrigger = null;
          if (wasJustOpenedByHover) this.open(trigger);
          else this.toggle(trigger);
        });
        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hoverOpenedTrigger = trigger;
          this.open(trigger);
        });
        item.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hoverOpenedTrigger = null;
          this.scheduleClose();
        });
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.close(trigger);
        });
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const activeTrigger = this.triggers.find((trigger) => trigger.getAttribute('aria-expanded') === 'true');
          this.closeAll();
          activeTrigger?.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeAll();
      });
    }

    panelFor(trigger) {
      return this.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
    }

    open(trigger) {
      window.clearTimeout(this.closeTimer);
      this.triggers.forEach((otherTrigger) => {
        if (otherTrigger !== trigger) this.close(otherTrigger);
      });
      const panel = this.panelFor(trigger);
      if (!panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }

    close(trigger) {
      const panel = this.panelFor(trigger);
      trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    }

    toggle(trigger) {
      if (trigger.getAttribute('aria-expanded') === 'true') this.close(trigger);
      else this.open(trigger);
    }

    scheduleClose() {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.closeAll(), 180);
    }

    closeAll() {
      this.hoverOpenedTrigger = null;
      this.triggers.forEach((trigger) => this.close(trigger));
    }
  });
}

if (!window.navigationRedesignMobileEventsBound) {
  window.navigationRedesignMobileEventsBound = true;

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-nav-redesign-drawer-close]');
    if (closeButton) {
      const drawer = closeButton.closest('header-drawer');
      drawer?.querySelector(':scope > details > summary')?.click();
      return;
    }

    const submenuTrigger = event.target.closest(
      '.header__drawer-mobile--redesign .mobile-navigation-no-sub > li > details > summary'
    );
    if (!submenuTrigger) return;

    window.requestAnimationFrame(() => {
      const submenuScroller = submenuTrigger.nextElementSibling?.querySelector('.menu-drawer__inner-submenu');
      if (submenuScroller) submenuScroller.scrollTop = 0;
    });
  });
}

if (!window.navigationRedesignCartCountObserver) {
  const cartIconBubble = document.querySelector('#cart-icon-bubble');

  if (cartIconBubble) {
    const syncNavigationCartCount = () => {
      const cartCountSource = cartIconBubble.querySelector('[data-cart-count]');
      if (!cartCountSource) return;

      const itemCount = Number.parseInt(cartCountSource.dataset.cartCount, 10) || 0;
      const visibleCount = itemCount < 100 ? String(itemCount) : '99+';
      const accessibleLabel = cartIconBubble.querySelector('.cart-count-bubble .visually-hidden')?.textContent?.trim();

      document.querySelectorAll('[data-nav-redesign-cart-count]').forEach((countElement) => {
        if (countElement.textContent.trim() !== visibleCount) countElement.textContent = visibleCount;
      });

      if (accessibleLabel) {
        document.querySelectorAll('[data-nav-redesign-cart-label]').forEach((labelElement) => {
          if (labelElement.textContent.trim() !== accessibleLabel) labelElement.textContent = accessibleLabel;
        });
      }
    };

    syncNavigationCartCount();

    window.navigationRedesignCartCountObserver = new MutationObserver(syncNavigationCartCount);
    window.navigationRedesignCartCountObserver.observe(cartIconBubble, {
      childList: true,
      subtree: true
    });
  }
}